<script lang="ts" setup>
	import type { ClassContext } from '@/types'

	export type MycoverOverviewCard = {
		noListPoint?: boolean
		listClass?: ClassContext
		listStyle?: StyleValue
		valueClass?: ClassContext
		titleClass?: ClassContext
		value: string | number | boolean | undefined | null
		title?: string
		disabled?: boolean
		[id: string]: unknown
	}

	defineProps<MycoverOverviewCard>()
</script>

<template>
	<div class="min-h-[56px] flex-none gap-x-2 rounded-lg border px-3 py-2">
		<div
			v-if="!noListPoint"
			class="mt-2 h-[6px] w-[6px] flex-none rounded-full"
			:class="listClass"
			:style="listStyle"
		/>
		<div class="space-y-1">
			<span :class="cn('text-[10px] font-medium capitalize tracking-wide text-gray-500', titleClass)">
				{{ title }}
			</span>

			<h3
				:class="
					cn('max-w-[100px] overflow-hidden text-ellipsis text-base font-semibold text-gray-800', valueClass)
				"
				:title="String(value)"
			>
				{{ value }}
			</h3>
		</div>
	</div>
</template>
